import api from '../httpClient';

export type InAppNotification = {
  id: string;
  type: 'meeting_notification' | 'mentorship_recap_ready';
  channel: 'in_app';
  send_at: string;
  status: string;
  meeting: {
    id: string | null;
    title: string;
    start_time: string | null;
    time_zone: string;
  };
  /** Present for mentorship_recap_ready: the pair's record to open. */
  record?: {
    relationship_id: string | null;
    recap_id: string | null;
    counterpart_name: string;
    url: string;
  };
};

const getDueInAppNotifications = async () => {
  const resp = await api.get<InAppNotification[]>('/api/user/notifications/in-app/due/');
  return resp.data;
};

const acknowledgeInAppNotification = async (notificationId: string) => {
  const resp = await api.post<{ id: string; read_at: string }>(
    `/api/user/notifications/in-app/${notificationId}/ack/`,
  );
  return resp.data;
};

export const notifications = {
  getDueInAppNotifications,
  acknowledgeInAppNotification,
};
